var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "page-header",
        {
          attrs: {
            title: _vm.isEditMode
              ? _vm.$t("pages.admin.video.upload.page_title_edit")
              : _vm.$t("pages.admin.video.upload.page_title"),
            "icon-class": "mdi mdi-frequently-asked-questions"
          }
        },
        [
          _vm.isEditMode
            ? _c(
                "a",
                {
                  staticClass: "btn btn-sm btn-dark float-right mb-4",
                  attrs: {
                    href: _vm.$router.resolve({
                      name: "gym.video",
                      params: { video: this.$route.params.video }
                    }).href,
                    target: "_blank"
                  }
                },
                [_vm._v("\n            Video ukucke\n        ")]
              )
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-12 grid-margin stretch-card" }, [
          _c("div", { staticClass: "card shadow-sm" }, [
            _c(
              "div",
              { staticClass: "card-body" },
              [
                !_vm.showUploadProgress
                  ? _c("static-loading-indicator-icon")
                  : _vm._e(),
                _vm._v(" "),
                _vm.showUploadProgress
                  ? _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-md-12" }, [
                        _c("h5", { staticClass: "card-title" }, [
                          _vm._v(
                            "Upload progress (" +
                              _vm._s(_vm.videoUploadProgress) +
                              "%)"
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "progress" }, [
                          _c("div", {
                            staticClass:
                              "progress-bar progress-bar-striped progress-bar-animated bg-primary",
                            style: "width:" + _vm.videoUploadProgress + "%",
                            attrs: {
                              role: "progressbar",
                              "aria-valuenow": _vm.videoUploadProgress,
                              "aria-valuemin": "0",
                              "aria-valuemax": "100"
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "alert alert-info mt-3" }, [
                          _vm._v(
                            "\n                                " +
                              _vm._s(
                                _vm.$t(
                                  "pages.admin.video.upload.uploading.dont_leave_page"
                                )
                              ) +
                              "\n                            "
                          )
                        ])
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                !_vm.$store.getters.shouldLoadLocal
                  ? _c(
                      "div",
                      [
                        _vm.isEditMode
                          ? _c("div", { staticClass: "form-group" }, [
                              _c("strong", [_vm._v("Thumbnail")]),
                              _vm._v(" "),
                              _c("div", { staticClass: "row" }, [
                                _c("div", { staticClass: "col-md-4 mt-3" }, [
                                  _vm.existingThumbnailUrl !== null
                                    ? _c("img", {
                                        staticClass: "img-fluid",
                                        staticStyle: {
                                          "border-radius": "8px",
                                          "max-height": "200px"
                                        },
                                        attrs: { src: _vm.existingThumbnailUrl }
                                      })
                                    : _vm._e()
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-md-8" }, [
                                  _c("input", {
                                    staticClass: "file-upload-default",
                                    class: {
                                      "is-invalid": _vm.$errors.has("thumbnail")
                                    },
                                    attrs: {
                                      type: "file",
                                      id: "thumbnail-default"
                                    },
                                    on: { change: _vm.thumbnailSelected }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "input-group cursor-pointer col-xs-12",
                                      on: {
                                        click: _vm.showSelectThumbnailDialog
                                      }
                                    },
                                    [
                                      _c("input", {
                                        staticClass:
                                          "form-control file-upload-info",
                                        attrs: {
                                          type: "text",
                                          id: "thumbnail-upload",
                                          disabled: "",
                                          placeholder: "Auswielen"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _vm._m(0),
                                      _vm._v(" "),
                                      _c("error", {
                                        attrs: { input: "thumbnail" }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "text-muted mt-2" },
                                    [
                                      _vm._v(
                                        "\n                                        D'Bild muss eng Opléisung vun 1920x1080 hun.\n                                    "
                                      )
                                    ]
                                  )
                                ])
                              ])
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "language-switcher-nav",
                          {
                            attrs: { language: _vm.selectedLanguage },
                            on: {
                              "update:language": function($event) {
                                _vm.selectedLanguage = $event
                              }
                            }
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "form-group" },
                              [
                                _c("label", { attrs: { for: "title" } }, [
                                  _c("strong", [
                                    _vm._v(
                                      "\n                                        " +
                                        _vm._s(
                                          _vm.$t(
                                            "pages.admin.video.upload.title"
                                          )
                                        ) +
                                        "\n                                    "
                                    )
                                  ])
                                ]),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.title[_vm.selectedLanguage],
                                      expression: "title[selectedLanguage]"
                                    }
                                  ],
                                  staticClass: "form-control",
                                  class: {
                                    "is-invalid": _vm.$errors.has("title")
                                  },
                                  attrs: {
                                    type: "text",
                                    id: "title",
                                    placeholder: _vm.$t(
                                      "pages.admin.video.upload.title"
                                    )
                                  },
                                  domProps: {
                                    value: _vm.title[_vm.selectedLanguage]
                                  },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.title,
                                        _vm.selectedLanguage,
                                        $event.target.value
                                      )
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c("error", {
                                  attrs: {
                                    input: "title." + _vm.selectedLanguage
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "form-group" },
                              [
                                _c("label", { attrs: { for: "equipment" } }, [
                                  _c("strong", [
                                    _vm._v(
                                      "\n                                        " +
                                        _vm._s(
                                          _vm.$t(
                                            "pages.admin.video.upload.equipment_needed"
                                          )
                                        ) +
                                        "\n                                    "
                                    )
                                  ])
                                ]),
                                _vm._v(" "),
                                _c("textarea", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value:
                                        _vm.equipment[_vm.selectedLanguage],
                                      expression: "equipment[selectedLanguage]"
                                    }
                                  ],
                                  staticClass: "form-control",
                                  attrs: {
                                    id: "equipment",
                                    placeholder: _vm.$t(
                                      "pages.admin.video.upload.equipment_needed"
                                    )
                                  },
                                  domProps: {
                                    value: _vm.equipment[_vm.selectedLanguage]
                                  },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.equipment,
                                        _vm.selectedLanguage,
                                        $event.target.value
                                      )
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c("error", {
                                  attrs: {
                                    input: "equipment." + _vm.selectedLanguage
                                  }
                                })
                              ],
                              1
                            )
                          ]
                        ),
                        _vm._v(" "),
                        !_vm.isEditMode
                          ? _c("div", { staticClass: "form-group" }, [
                              _c("label", [
                                _c("strong", [
                                  _vm._v(
                                    "\n                                    " +
                                      _vm._s(
                                        _vm.$t(
                                          "pages.admin.video.upload.select_video"
                                        )
                                      ) +
                                      "\n                                "
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("input", {
                                staticClass: "file-upload-default",
                                class: {
                                  "is-invalid": _vm.$errors.has("file")
                                },
                                attrs: { type: "file", id: "file" },
                                on: { change: _vm.fileSelected }
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "input-group cursor-pointer col-xs-12",
                                  on: { click: _vm.showSelectFileDialog }
                                },
                                [
                                  _c("input", {
                                    staticClass:
                                      "form-control file-upload-info",
                                    attrs: {
                                      type: "text",
                                      disabled: "",
                                      placeholder: _vm.$t(
                                        "pages.admin.video.upload.select_video"
                                      )
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticClass: "input-group-append" },
                                    [
                                      _c(
                                        "button",
                                        {
                                          staticClass:
                                            "file-upload-browse btn btn-gradient-primary",
                                          attrs: { type: "button" }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.$t("actions.select"))
                                          )
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("error", { attrs: { input: "file" } })
                                ],
                                1
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "form-group" },
                          [
                            _c("strong", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "pages.admin.video.upload.select_goals"
                                  )
                                )
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "row" },
                              _vm._l(_vm.goalsByGroup, function(group, i) {
                                return _c(
                                  "div",
                                  { staticClass: "col-4 pt-3" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "card bg-light rounded" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "card-body" },
                                          [
                                            _c("strong", [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "pages.admin.video.upload.goal_group_" +
                                                        i
                                                    )
                                                  )
                                                )
                                              ])
                                            ]),
                                            _vm._v(" "),
                                            _vm._l(group, function(item) {
                                              return _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "form-check form-check-primary"
                                                },
                                                [
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass:
                                                        "form-check-label"
                                                    },
                                                    [
                                                      _c("input", {
                                                        staticClass:
                                                          "form-check-input",
                                                        attrs: {
                                                          type: "checkbox"
                                                        },
                                                        domProps: {
                                                          checked: _vm.selectedGoals.includes(
                                                            item.id
                                                          )
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.addOrRemoveGoal(
                                                              item.id
                                                            )
                                                          }
                                                        }
                                                      }),
                                                      _vm._v(
                                                        "\n                                                    " +
                                                          _vm._s(item.label) +
                                                          "\n                                                    "
                                                      ),
                                                      _c("i", {
                                                        staticClass:
                                                          "input-helper"
                                                      })
                                                    ]
                                                  )
                                                ]
                                              )
                                            })
                                          ],
                                          2
                                        )
                                      ]
                                    )
                                  ]
                                )
                              }),
                              0
                            ),
                            _vm._v(" "),
                            _c("error", { attrs: { input: "selected_goals" } })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "form-group" },
                          [
                            _c(
                              "label",
                              { attrs: { for: "preferred_language" } },
                              [
                                _c("strong", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "pages.admin.video.upload.select_series"
                                      )
                                    )
                                  )
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.series_id,
                                    expression: "series_id"
                                  }
                                ],
                                staticClass: "form-control",
                                class: {
                                  "is-invalid": _vm.$errors.has("series_id")
                                },
                                attrs: {
                                  id: "preferred_language",
                                  placeholder: _vm.$t(
                                    "pages.admin.video.upload.select_series"
                                  )
                                },
                                on: {
                                  change: function($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call($event.target.options, function(o) {
                                        return o.selected
                                      })
                                      .map(function(o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.series_id = $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  }
                                }
                              },
                              [
                                _c("option", { attrs: { value: "" } }, [
                                  _vm._v(
                                    "--- " +
                                      _vm._s(
                                        _vm.$t(
                                          "pages.admin.video.upload.no_series"
                                        )
                                      ) +
                                      " ---"
                                  )
                                ]),
                                _vm._v(" "),
                                _vm._l(_vm.seriesList, function(series) {
                                  return _c(
                                    "option",
                                    { domProps: { value: series.id } },
                                    [
                                      _vm._v(
                                        _vm._s(series.title[_vm.$i18n.locale])
                                      )
                                    ]
                                  )
                                })
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _c("error", { attrs: { input: "series_id" } }),
                            _vm._v(" "),
                            _c(
                              "small",
                              { staticClass: "form-text text-muted" },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "pages.admin.video.upload.series_explanation"
                                    )
                                  )
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "row" }, [
                          _c("div", { staticClass: "col-md-6" }, [
                            _c(
                              "div",
                              { staticClass: "form-group" },
                              [
                                _c("label", { attrs: { for: "intensity" } }, [
                                  _c("strong", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "pages.admin.video.upload.intensity"
                                        )
                                      ) + ":"
                                    )
                                  ]),
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.intensity) +
                                      "\n                                    "
                                  )
                                ]),
                                _vm._v(" "),
                                _c("range-slider", {
                                  staticClass: "slider",
                                  attrs: {
                                    id: "intensity",
                                    min: "1",
                                    max: "10",
                                    step: "1"
                                  },
                                  model: {
                                    value: _vm.intensity,
                                    callback: function($$v) {
                                      _vm.intensity = $$v
                                    },
                                    expression: "intensity"
                                  }
                                }),
                                _vm._v(" "),
                                _c("error", { attrs: { input: "intensity" } })
                              ],
                              1
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-md-6" }, [
                            _c(
                              "div",
                              { staticClass: "form-group" },
                              [
                                _c("label", { attrs: { for: "level" } }, [
                                  _c("strong", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("pages.admin.video.upload.level")
                                      ) + ":"
                                    )
                                  ]),
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.labelByLevel) +
                                      "\n                                    "
                                  )
                                ]),
                                _vm._v(" "),
                                _c("range-slider", {
                                  staticClass: "slider",
                                  attrs: {
                                    id: "level",
                                    min: "1",
                                    max: "3",
                                    step: "1"
                                  },
                                  model: {
                                    value: _vm.level,
                                    callback: function($$v) {
                                      _vm.level = $$v
                                    },
                                    expression: "level"
                                  }
                                }),
                                _vm._v(" "),
                                _c("error", { attrs: { input: "level" } })
                              ],
                              1
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "row" }, [
                          _c("div", { staticClass: "col-md-12" }, [
                            _c(
                              "div",
                              { staticClass: "form-group" },
                              [
                                _c("label", { attrs: { for: "duration" } }, [
                                  _c("strong", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "pages.admin.video.upload.duration_in_minutes"
                                        )
                                      )
                                    )
                                  ])
                                ]),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.duration_in_minutes,
                                      expression: "duration_in_minutes"
                                    }
                                  ],
                                  staticClass: "form-control",
                                  attrs: {
                                    type: "number",
                                    min: "1",
                                    max: "240",
                                    id: "duration",
                                    placeholder: _vm.$t(
                                      "pages.admin.video.upload.duration_in_minutes"
                                    )
                                  },
                                  domProps: { value: _vm.duration_in_minutes },
                                  on: {
                                    change: _vm.durationChanged,
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.duration_in_minutes =
                                        $event.target.value
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c("error", { attrs: { input: "duration" } })
                              ],
                              1
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-primary",
                            on: { click: _vm.save }
                          },
                          [
                            _vm._v(
                              "\n                            " +
                                _vm._s(
                                  _vm.isEditMode
                                    ? _vm.$t("actions.update")
                                    : _vm.$t("actions.upload")
                                ) +
                                "\n                        "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ],
              1
            )
          ])
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "input-group-append" }, [
      _c(
        "button",
        {
          staticClass: "file-upload-browse btn btn-gradient-primary",
          attrs: { type: "button" }
        },
        [_vm._v("Thumbnail ersetze")]
      )
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }